"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
var _Button = _interopRequireDefault(require("@concur/nui-widgets/lib/Buttons/Button"));
var _InputField = _interopRequireDefault(require("@concur/nui-widgets/lib/InputField/InputField"));
var _utils = require("../utils");
!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./style/SearchBar.css") : void 0;
var _withRouter = require("../HOCs/withRouter");
var _withAppContext = require("../HOCs/withAppContext");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SearchBar = /*#__PURE__*/function (_Component) {
  function SearchBar(props) {
    var _this;
    _classCallCheck(this, SearchBar);
    _this = _callSuper(this, SearchBar, [props]);
    _defineProperty(_this, "setSearchText", function (e) {
      _this.setState({
        searchText: e.target.value
      });
    });
    _defineProperty(_this, "handleSearch", function (e) {
      e.preventDefault();
      var _this$props = _this.props,
        pathname = _this$props.location.pathname,
        navigate = _this$props.navigate;
      var searchText = _this.state.searchText;
      if (!(searchText || '').trim()) {
        return;
      }
      var path = (0, _utils.getAppCenterPathName)(pathname);
      var escapedSearchTerm = encodeURIComponent(searchText);
      navigate("".concat(path, "/search/").concat(escapedSearchTerm), {
        replace: true
      });
    });
    _this.state = {
      searchText: props.params.term || ''
    };
    return _this;
  }
  _inherits(SearchBar, _Component);
  return _createClass(SearchBar, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.location.pathname !== prevProps.location.pathname) {
        this.setState({
          searchText: this.props.params.term || ''
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var formatter = this.props.formatter;
      var searchText = this.state.searchText;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "search-bar-container",
        role: "search"
      }, /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSearch
      }, /*#__PURE__*/_react.default.createElement(_InputField.default, {
        className: "ac-search-bar",
        label: formatter.formattedMessage({
          id: 'FindApps'
        }),
        value: searchText,
        onChange: this.setSearchText,
        decorators: {
          tailStart: /*#__PURE__*/_react.default.createElement(_Button.default, {
            id: "ac-search-btn",
            className: "pull-right",
            type: "default",
            onClick: function onClick(e) {
              return _this2.handleSearch(e);
            }
          }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
            id: "Search"
          }))
        }
      })));
    }
  }]);
}(_react.Component);
SearchBar.propTypes = {
  navigate: _propTypes.default.func.isRequired,
  // eslint-disable-line react/forbid-prop-types
  location: _propTypes.default.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  formatter: _propTypes.default.object // eslint-disable-line react/forbid-prop-types
};
var _default = exports.default = (0, _withRouter.withRouter)((0, _withAppContext.withAppContext)((0, _nuiIntlRuntime.withFormatter)(SearchBar)));